import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import type { EmployeeManualOrder } from '@/api/employee-manual-order'

interface ManualOrderCancelDialogProps {
  order: EmployeeManualOrder | null
  open: boolean
  isSubmitting?: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
}

export function ManualOrderCancelDialog({
  order,
  open,
  isSubmitting = false,
  onOpenChange,
  onConfirm,
}: ManualOrderCancelDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[420px]">
        <DialogHeader>
          <DialogTitle>取消订单</DialogTitle>
          <DialogDescription>
            取消后订单将被标记为已取消，库存将回退。此操作不可撤销。
          </DialogDescription>
        </DialogHeader>

        {order && (
          <div className="rounded-md border bg-muted/30 p-4 text-sm">
            <div className="text-muted-foreground">订单号</div>
            <div className="font-mono font-medium">{order.order_id}</div>
            <div className="mt-3 text-muted-foreground">订单金额</div>
            <div className="text-xl font-bold">¥{order.pay_price.toFixed(2)}</div>
            <div className="mt-3 text-muted-foreground">收货人</div>
            <div>{order.real_name || '-'} {order.user_phone || ''}</div>
          </div>
        )}

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={isSubmitting}>
            返回
          </Button>
          <Button variant="destructive" onClick={onConfirm} disabled={!order || isSubmitting}>
            {isSubmitting ? '取消中...' : '确认取消订单'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
